// src/components/AllowedOptions/AllowedOptionsSelectorTable/parts/TableBody.tsx
import clsx from 'clsx';
import { AllowedOptionRow, AllowedOptionColumn } from '../types';
import Checkbox from '../../Forms/Input/Checkbox';

type Props = {
  rows: AllowedOptionRow[];
  onToggleOne: (index: number) => void;
  columns: AllowedOptionColumn[];
};

const TableBody: React.FC<Props> = ({ rows, onToggleOne, columns }) => {
  return (
    <tbody className="text-gray-700 dark:text-gray-300 bg-white text-sm dark:bg-boxdark">
      {rows.length > 0 ? (
        rows.map((row, idx) => (
          <tr key={row.code ?? idx} className={clsx('transition-colors duration-150')}>
            {/* Checkbox */}
            <td className="py-4 pl-4 pr-2 align-middle">
              <Checkbox
                id={`row-${idx}`}
                checked={!!row.selected}
                onChange={() => onToggleOne(idx)}
              />
            </td>

            {/* Columnas dinámicas */}
            {columns.map((col, colIdx) => (
              <td key={colIdx} className="whitespace-nowrap px-4 py-4">
                {col.render ? col.render(row[col.key], row) : (row[col.key] as React.ReactNode)}
              </td>
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td
            colSpan={columns.length + 1}
            className="text-gray-600 dark:text-gray-400 py-6 text-center"
          >
            No hay registros disponibles.
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default TableBody;
